import { NewsletterInterface, NewsletterSubscription } from '@/models/newsletter.model';
import { axiosWdw, domainEndpoint } from './axios';

const endpoint = '/newsletter/';

export default {
  get() {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data.filter(
            (newsletter: NewsletterInterface) => newsletter.disabled === 0
            // (newsletter: NewsletterInterface) => newsletter
          );
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  getSingleNewsletter(newsletterid: number) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + newsletterid,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  subscribe(newsletterid: number, email: string, captchaId = 0, captchaAnswer = '') {
    return new Promise<NewsletterSubscription>((res, rej) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + newsletterid + '/subscribe',
        data: { email: email, captcha_id: captchaId, captcha_answer: captchaAnswer },
      })
        .then(response => {
          if (response && response.data.success) {
            res(response.data.data);
          } else {
            console.log('error');
          }
        })
        .catch(error => {
          rej(error);
        });
    });
  },

  getSubscription(newsletterid: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + newsletterid + '/subscription',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(null);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getSubscriptionListOfUser(userid: number) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + 'subscription?user=' + userid,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  verifyToken(newsletterid: number, token: string) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + newsletterid + '/verify',
      params: { token: token },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  unsubscribe(newsletterid: number, token: string) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + newsletterid + '/unsubscribe',
      params: { token: token },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  subscribe_user(newsletterid: number) {
    return axiosWdw({
      method: 'POST',
      url: domainEndpoint() + endpoint + newsletterid + '/subscribe_user',
    }).then(response => {
      if (response && response.data.success) {
        return response.data.data;
      } else {
        console.log('error');
      }
    });
  },

  unsubscribe_user(newsletterid: number) {
    return axiosWdw({
      method: 'POST',
      url: domainEndpoint() + endpoint + newsletterid + '/unsubscribe_user',
    }).then(response => {
      if (response && response.data.success) {
        return response.data.data;
      } else {
        console.log('erro');
      }
    });
  },
};
